import React from "react";

const HTMLBlock = (props) => {
    return (
        <div className="block" id={"html-block-" + props.block.id} dangerouslySetInnerHTML={{__html: props.block.html}} />
    )
}

export default HTMLBlock;